import { BidCategorySchema, BidNameSchema, BidStatusSchema } from "@/components/_Shared/Form/Schemas/Bid"
import { DateDueSchema } from "@/components/_Shared/Form/Schemas/DateDueSchema"
import { DatesSchema } from "@/components/_Shared/Form/Schemas/DatesSchema"
import { ManagerSchema } from "@/components/_Shared/Form/Schemas/ManagerSchema"
import { TemplateSchema } from "@/components/_Shared/Form/Schemas/TemplateSchema"
import { DescriptionSchema } from "@/components/_Shared/Form/Schemas/DescriptionSchema"
import { CitySchema } from "@/components/_Shared/Form/Schemas/CitySchema"
import { z } from "zod"

export const BidFormSchema = z.object({
    no_date_due: z.boolean().optional(),
    isDeadline: z.boolean(),
    folder_location: z.string().optional(),
})
    .merge(BidNameSchema)
    .merge(DatesSchema)
    .merge(BidStatusSchema)
    .merge(BidCategorySchema)
    .merge(ManagerSchema)
    .merge(DateDueSchema)
    .merge(TemplateSchema)
    .merge(CitySchema)
    .merge(DescriptionSchema)